export default "__VITE_ASSET__DVDeOsgP__"